import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { MonitorConversationDetails } from "./routes";
export default store => ({
  path: "monitor",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "messaging-monitor-conversation" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [MonitorConversationDetails(store)],
});
